import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  type DashboardSearch,
  dashboardSearchFrom,
} from '@/components/dashboard-filters/dashboard-period'
import { InventoryDashboardScreen } from '@/features/inventory-dashboard/inventory-dashboard-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/')({
  validateSearch: (search: Record<string, unknown>): DashboardSearch => dashboardSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock.view')) throw redirect({ to: '/' })
  },
  component: InventoryOverviewRoute,
})

function InventoryOverviewRoute() {
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <InventoryDashboardScreen
      search={Route.useSearch()}
      onSearchChange={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }) })}
    />
  )
}
